import { Popover } from '@mui/material';
import styled from 'styled-components';
import CloseOverlayButton from '../CloseOverlayButton';
import { floatingComponentStyles } from '../../styles/shareableStyles';

export const StyledPopover = styled(Popover)`
  &&& {
    .MuiPaper-root {
      opacity: 1;
      overflow: visible;
      background-color: unset;
      box-shadow: unset;
    }
  }
`;

export const Window = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Wrapper = styled.div`
  ${floatingComponentStyles};
`;

export const IconContainer = styled(CloseOverlayButton)`
  flex: 0 0 auto;
  margin-left: 8px;
`;
